import type { StorefrontAvailabilityNotificationDeleteResponseType } from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSellarCurrentBusiness } from "../../../../useSellarCurrentBusiness.shared";
import { useFirebaseUser } from "../../../../useFirebaseUser.shared";
import { apiV2AssertResponse, apiV2Request } from "../../apiV2Request";
import { ServerStateKeys } from "../../ServerStateKeys";

export const useSupplierStorefrontAvailabilityNotificationDelete = ({
  notificationId,
  supplierId,
}: {
  notificationId: number;
  supplierId: number;
}) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: () =>
      apiV2Request({
        user,
        business,
        method: "delete",
        path: `suppliers/${supplierId}/storefront/availability/notification/${notificationId}`,
      }).then(
        (data) =>
          apiV2AssertResponse(data)
            .data as StorefrontAvailabilityNotificationDeleteResponseType,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [
          business?.id,
          ServerStateKeys.StorefrontAvailabilityNotification,
          supplierId,
        ],
      });
    },
  });
};
